import React, { useState } from "react";
import Modal from "react-modal";
import SearchNButtons from "../../common-components/SearchNButtons";
import DietTypeForm from "./DietTypeForm";

const DietTypesFilters = ({
  filters,
  setFilters,
  searchFilterApplied,
  onClickSearch,
  callFunction,
}) => {
  const [modals, setModal] = useState(false);

  return (
    <>
      <Modal
        isOpen={modals}
        onRequestClose={() => {
          setModal(false);
        }}
        contentLabel="Add Diet Type Modal"
        ariaHideApp={false}
      >
        <DietTypeForm closeModal={() => setModal(false)} callFunction={callFunction} />
      </Modal>

      <SearchNButtons
        pageName={"diet-type"}
        btnText={"+ Add"}
        filters={filters}
        setFilters={setFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickAdd={() => setModal(true)}
      />
    </>
  );
};

export default DietTypesFilters;
